import { motion } from "framer-motion";
import { Reveal, staggerContainer, staggerItem } from "./Reveal";
import { AmbientOrbs } from "./Ambient";
import { JOURNEY } from "@/lib/data";

export const ClientJourney = () => (
  <section id="journey" className="relative overflow-hidden bg-[rgb(238,242,250)] py-16 md:py-20" data-testid="journey-section">
    <AmbientOrbs />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <div className="max-w-2xl">
        <Reveal>
          <span className="inline-flex items-center rounded-full border border-emerald2-300/40 bg-emerald2-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-emerald2-600">
            Client Journey
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-navy-900 md:text-4xl lg:text-5xl">
            A simple, transparent process
          </h2>
        </Reveal>
      </div>

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, margin: "-60px" }}
        className="mt-16 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3"
      >
        {JOURNEY.map((step, i) => {
          const green = i % 2 !== 0;
          return (
            <motion.div key={step.no} variants={staggerItem} className="relative" data-testid={`journey-step-${i}`}>
              <div className="flex items-center gap-4">
                <span className={`text-6xl font-extrabold leading-none ${green ? "text-stroke-blue" : "text-stroke-navy"}`}>
                  {step.no}
                </span>
                <span className={`h-px flex-1 bg-gradient-to-r to-transparent ${green ? "from-emerald2-500/60" : "from-gold-500/60"}`} />
              </div>
              <h3 className="mt-5 text-2xl font-semibold text-navy-900">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-slate-600">{step.desc}</p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);
